import { inject, Injectable } from '@angular/core';
import { Database, get, ref, set } from '@angular/fire/database';

import { LanguageModel } from '../models/language.model';

@Injectable({
  providedIn: 'root',
})
export class LanguagesService {
  private rtdb = inject(Database);

  async getLanguages(hotelUid: string): Promise<LanguageModel[]> {
    const path = `language/${hotelUid}`;
    const languagesRef = ref(this.rtdb, path);
    const languages = await get(languagesRef).then((snapshot) => snapshot.val());
    return (languages as LanguageModel[]).filter((lang) => lang.active);
  }

  saveHotelLanguages(hotelUid: string, languages: LanguageModel[]) {
    const path = `language/${hotelUid}`;
    const languagesRef = ref(this.rtdb, path);
    return set(languagesRef, languages);
  }
}
